module.exports = __webpack_public_path__ + "static/media/close-icon.564c513e.svg";